module.exports = __webpack_public_path__ + "img/6.2ed20edc.jpg";